// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1XSuH","actionsCol":"EnrolledClinics_actionsCol__3SXvg"};